import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuardService implements CanActivate {

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this.authenticationService.currentUserValue;
    if (currentUser) {
      if (currentUser.is_default_password_changed !== null && currentUser.is_default_password_changed === false) {
        this.router.navigate(['/first-login'], { queryParams: { returnUrl: state.url } });
      } 
     
      return true;
    }
    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });

    return false;
  }
}
